import { Routes } from '@angular/router';
import { authGuard, loginGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./views//login/login').then(m => m.Login),
    canActivate: [loginGuard]  // Redirect to dashboard if already logged in
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./views/dashboard/dashboard').then(m => m.Dashboard),
    canActivate: [authGuard]  // Require authentication
  },
  {
    path: 'royalties',
    loadComponent: () => import('./views/royalties/royalties').then(m => m.Royalties),
    canActivate: [authGuard]  // Require authentication
  },
  {
    path: 'royalties/platform-details/:platform/:period',
    loadComponent: () => import('./views/platform-details/platform-details').then(m => m.PlatformDetails),
    canActivate: [authGuard]  // Require authentication
  },
  {
    path: 'royalties/track-details/:track/:period',
    loadComponent: () => import('./views/track-details/track-details').then(m => m.TrackDetails),
    canActivate: [authGuard]  // Require authentication
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/login'
  }
];
